
webpack.register(
    'modules/erin-hills/erin-hills',
    function() {
        return import('modules/erin-hills/erin-hills');
    },
    true
);